import React from 'react'
import {ServerConfig} from 'config'

import List from '../../components/EntryListAndEdit/List'


const Employees = () => {
  const editable_fields = [
    ["first_name", "First name (*)"],
    ["last_name", "Last name (*)"],
    //["business_name", "Business name"],
    ["email", "Email (*)"],
    //["paypal_email", "Paypal Email"],
    ["phone_number", "Phone number (*)"],
    ["street", "Street"],
    ["housenumber", "Housenumber"],
    ["zipcode", "Zipcode"],
    ["city", "City"],
    ["state", "State"],
    ["password", "Password (*)"]
  ];

	return (
		<>
		    <List 
          list_get_url = {`${ServerConfig.SERVER_URL}/employee/`}
          detail_get_url = {`${ServerConfig.SERVER_URL}/employee/`}
          detail_put_url = {`${ServerConfig.SERVER_URL}/employee/`}
          add_new_url = {`${ServerConfig.SERVER_URL}/employee/`}

          column_names = {["id", "first_name", "last_name", "email", "phone_number", "edit"]}
          header_names = {["ID", "First Name", "Last Name", "Email", "Phone", ""]}

          optional_column_names={["zipcode", "city", "housenumber", "street"]}
          optional_header_names={["Zip", "City", "Hnr", "Street"]}

          editable_fields = {editable_fields}
        />
		</>
		)
}

export default Employees
